import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation} from "react-i18next";
import "../css/TrackButton.css";
import { useLoaderData } from "react-router-dom";

function TrackPackageButton({ caption }) {
  const { order, trackingNumber } = useLoaderData() || "???";// provide a default value if these aren't present.
  const { t, i18n: { language }  } = useTranslation();
  const trackAnotherButtonCaption = caption || t('TrackButton.trackAnotherOrder');

    let contactAction = "https://www.appleexpress.com/contact";// default action
    if (order?.screenDetails?.supportEmailAction === 1) {
        contactAction = `mailto:${order.screenDetails.supportEmail}?subject=Web%20Enquiry%20Order`;
        
        // If the tracking number exists, include it in the subject of the email
        if (trackingNumber !== undefined)
        {
            contactAction += "%20" + trackingNumber;
        }
    }
    // For french, extend the width of the button so the whole text is legible
    let isFrench = language.toString().toLowerCase().startsWith ('f');
    
  return (
      <div
          className="sticky-top d-flex justify-content-end mt-3"
          style={{pointerEvents: "none"}}
      >
        <Link
            to="/"
            className="btnTrackPackage text-center"
            style={{pointerEvents: "auto", marginRight: "10px"}}
        >
          {trackAnotherButtonCaption}
        </Link>
&nbsp;
        <Link
            to={contactAction}
            className="btnTrackPackage text-center"
            style={{pointerEvents: "auto", marginRight: "10px",  width: (isFrench ?'250px' : '')}}
        >
          <b>
              <Trans i18nKey="TrackButton.questionsContactUs">
                  Questions? Contact Us
              </Trans>
          </b>&nbsp;
        </Link>        
      </div>

  );
}

export default TrackPackageButton;
